const FilterIcon = ({ ...props }) => {
	return (
		<svg
			{...props}
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M17.8293 5C17.4175 3.83481 16.3062 3 15 3C13.6938 3 12.5825 3.83481 12.1707 5H3.5C3.22386 5 3 5.22386 3 5.5V6.5C3 6.77614 3.22386 7 3.5 7H12.1707C12.5825 8.16519 13.6938 9 15 9C16.3062 9 17.4175 8.16519 17.8293 7H20.5C20.7761 7 21 6.77614 21 6.5V5.5C21 5.22386 20.7761 5 20.5 5H17.8293ZM15 7C14.4477 7 14 6.55228 14 6C14 5.44772 14.4477 5 15 5C15.5523 5 16 5.44772 16 6C16 6.55228 15.5523 7 15 7Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.5 13H6.17071C6.58254 14.1652 7.69378 15 9 15C10.3062 15 11.4175 14.1652 11.8293 13H20.5C20.7761 13 21 12.7761 21 12.5V11.5C21 11.2239 20.7761 11 20.5 11H11.8293C11.4175 9.83481 10.3062 9 9 9C7.69378 9 6.58254 9.83481 6.17071 11H3.5C3.22386 11 3 11.2239 3 11.5V12.5C3 12.7761 3.22386 13 3.5 13ZM9 13C9.55228 13 10 12.5523 10 12C10 11.4477 9.55228 11 9 11C8.44772 11 8 11.4477 8 12C8 12.5523 8.44772 13 9 13Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M15 15C16.3062 15 17.4175 15.8348 17.8293 17H20.5C20.7761 17 21 17.2239 21 17.5V18.5C21 18.7761 20.7761 19 20.5 19H17.8293C17.4175 20.1652 16.3062 21 15 21C13.6938 21 12.5825 20.1652 12.1707 19H3.5C3.22386 19 3 18.7761 3 18.5V17.5C3 17.2239 3.22386 17 3.5 17H12.1707C12.5825 15.8348 13.6938 15 15 15ZM14 18C14 18.5523 14.4477 19 15 19C15.5523 19 16 18.5523 16 18C16 17.4477 15.5523 17 15 17C14.4477 17 14 17.4477 14 18Z"
				fill="currentColor"
			/>
		</svg>
	)
}

export default FilterIcon
